export var text = {
    group: 'inline',
    toDebugString: 
    // @ts-ignore
    process.env.NODE_ENV !== 'production' ? undefined : function () { return 'text_node'; },
};
//# sourceMappingURL=text.js.map